import { useEffect, useRef, type RefObject } from 'react';

/**
 * Whether Shift is held right now, as a ref.
 *
 * Range selection needs this because the change event a checkbox reports
 * carries no modifier keys, so the key state has to be tracked separately from
 * the click that consumes it. A ref rather than state: the value is read inside
 * an event handler and must never trigger a render of its own.
 */
export function useIsShiftPressed(): RefObject<boolean> {
  const isShiftPressed = useRef(false);

  useEffect(() => {
    const track = (event: KeyboardEvent) => {
      if (event.key === 'Shift') {
        isShiftPressed.current = event.type === 'keydown';
      }
    };
    document.addEventListener('keydown', track);
    document.addEventListener('keyup', track);
    return () => {
      document.removeEventListener('keydown', track);
      document.removeEventListener('keyup', track);
    };
  }, []);

  return isShiftPressed;
}
